<script lang="ts">
  export let src: string
  export let loading: 'lazy' | 'eager' = 'lazy'
</script>

<img {src} {loading} {...$$restProps} alt="" />
